export interface HeaderNavigationLayoutInput {
  containerWidth: number;
  leftBoundary: number;
  rightBoundary: number;
  contentWidth: number;
}

export interface HeaderNavigationLayout {
  left: number;
  width: number;
}

/**
 * Keeps the navigation centred while there is enough room. When either side
 * becomes constrained, shifts and then clips the navigation to the remaining
 * safe area instead of allowing it to overlap the header controls.
 */
export function calculateHeaderNavigationLayout({
  containerWidth,
  leftBoundary,
  rightBoundary,
  contentWidth,
}: HeaderNavigationLayoutInput): HeaderNavigationLayout {
  const safeContainerWidth = Math.max(0, containerWidth);
  const safeLeft = Math.min(safeContainerWidth, Math.max(0, leftBoundary));
  const safeRight = Math.min(
    safeContainerWidth,
    Math.max(safeLeft, rightBoundary)
  );
  const availableWidth = Math.max(0, safeRight - safeLeft);
  const width = Math.min(Math.max(0, contentWidth), availableWidth);
  const idealLeft = (safeContainerWidth - width) / 2;
  const maxLeft = Math.max(safeLeft, safeRight - width);
  const left = Math.min(Math.max(idealLeft, safeLeft), maxLeft);

  return { left, width };
}
